export const carouselInicio = [
    /*{
        "imagen" : "https://cdn.hidalgo.gob.mx/gobierno/images/veda/banner_veda.png"
    },*/
    {
        "imagen" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/dir5/Imagenes/PIBEH47B.png"
    },
    {
        "imagen" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/IndustrialBancaria/dir5/Imagenes/PPIBEH4.png"
    }
]